import { combineReducers } from "redux";
import authReducer from "./authReducer";
import systemsReducer from "./systemsReducer";
import HBReducer from "./HBReducer";


const reducers = combineReducers({
  system: systemsReducer,
  auth: authReducer,
  hostbill: HBReducer
});

export default reducers;